import script from "./LandingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__